import {
    SolicitarAutorizacionCreateFormComponent
} from '../solicitar-autorizacion-create-form/solicitar-autorizacion-create-form.component';
import {SolicitarAutorizacionCreateService} from '../services/solicitar-autorizacion-create.service';
import {Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {EvkCreateComponentBase, EvkResponseType, MessageCrudService} from '@evomatik/evk-common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs/internal/Observable';
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Component({
    selector: 'evk-solicitar-autorizacion',
    templateUrl: './solicitar-autorizacion-create.component.html',
    styleUrls: ['./solicitar-autorizacion-create.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SolicitarAutorizacionCreateComponent extends EvkCreateComponentBase<DiligenciaTareaModel> implements OnInit {

    constructor(public createService: SolicitarAutorizacionCreateService,
                public messagesCrudService: MessageCrudService,
                public dialogRef: MatDialogRef<SolicitarAutorizacionCreateComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        super(createService, messagesCrudService);
    }


    ngOnInit() {
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    @ViewChild(SolicitarAutorizacionCreateFormComponent, {static: false})
    set formComponent(autorizacionForm: SolicitarAutorizacionCreateFormComponent) {
        this.form = autorizacionForm.form;
    }


    beforeSave = (diligencia: DiligenciaTareaModel) => {
        return new Observable<DiligenciaTareaModel>(observer => {
            diligencia = this.data.diligencia;
            diligencia.unidadDestino = this.form.controls.organizacion.value;
            diligencia.usuarioDestino = this.form.controls.usuarioAsignado.value !== '' ? this.form.controls.usuarioAsignado.value : null;
            observer.next(diligencia);
        });
    }

    doneSave(response: EvkResponseType) {
        this.dialogRef.close(response);
        super.doneSave(response);
    }
}
